'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('lodash');
var queryString = require('query-string');

var BASE_URL = 'https://cloud-data.wix-code.com/v1/schemas';

var handleResponse = function handleResponse(response) {
  if (response.status >= 400) {
    var responseBody = response.json();
    throw new Error(responseBody && responseBody.message || '');
  } else {
    return response.json();
  }
};

var handleError = function handleError(err) {
  return Promise.reject(new Error('Unable to fetch result (' + err.message + ')'));
};

var schemaArrayToObject = function schemaArrayToObject(schemaArray) {
  return _.keyBy(schemaArray, 'id');
};

var WixDataSchemas = function () {
  function WixDataSchemas(fetch, signedInstance, gridAppId, options) {
    _classCallCheck(this, WixDataSchemas);

    this.signedInstance = signedInstance;
    this.fetch = function () {
      return fetch.apply(undefined, arguments);
    };
    this.baseUrl = options && options.baseUrl || BASE_URL;
    this.gridAppId = gridAppId;
  }

  _createClass(WixDataSchemas, [{
    key: 'bulkGet',
    value: function bulkGet(collectionNames) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { includeDeletedCollections: false, referencedCollectionsDepth: 0 };

      var query = {
        signedInstance: this.signedInstance,
        appId: this.gridAppId,
        depth: options.referencedCollectionsDepth || 0,
        includeDeleted: options.includeDeletedCollections || false
      };

      var collectionNamesArray = collectionNames instanceof Array ? collectionNames : (collectionNames || '').split(',');

      var schemaQueryParams = collectionNamesArray.map(function (collectionName) {
        return queryString.stringify({ schemaIds: collectionName });
      }).join('&');

      return this.fetch(this.baseUrl + '?' + queryString.stringify(query) + '&' + schemaQueryParams).then(handleResponse).then(function (result) {
        return schemaArrayToObject(result.schemas);
      }).catch(handleError);
    }
  }, {
    key: 'list',
    value: function list() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { includeDeletedCollections: false };

      var query = {
        signedInstance: this.signedInstance,
        appId: this.gridAppId,
        schemaIds: [],
        depth: 0,
        includeDeleted: options.includeDeletedCollections || false
      };

      return this.fetch(this.baseUrl + '?' + queryString.stringify(query)).then(handleResponse).then(function (result) {
        return schemaArrayToObject(result.schemas);
      }).catch(handleError);
    }
  }]);

  return WixDataSchemas;
}();

exports.default = WixDataSchemas;